export default __webpack_public_path__ + "static/media/luniu-logo.961c0172.png";